import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompetencyBuilderIndicatorSetAPIResponse } from 'src/app/private/shared/types/responses/competency-builder.responses';

@Component({
  selector: 'app-builder-leveled-competency',
  templateUrl: './builder-leveled-competency.component.html',
  styleUrls: ['./builder-leveled-competency.component.scss'],
  standalone: false,
})
export class BuilderLeveledCompetencyComponent {
  @Input() indicatorSet: CompetencyBuilderIndicatorSetAPIResponse;

  @Input() apiLoading: boolean;

  @Output() readonly deleteCompetencyEvent = new EventEmitter<number>();

  @Output() readonly badgeGraphicUploadedEvent = new EventEmitter();

  @Output() readonly updatingEvent = new EventEmitter<string>();
}
